export const link = 'https://api.prontuariosuasonline.com.br';//'http://127.0.0.1:8000'//

export const oauth = 'eR39RsrLMrsxr3nOsA056hp2Rd04d7IDrCv0krFu'